var map = {
	"./Avalanche.png": 837,
	"./Blackhawks.png": 838,
	"./Blue Jackets.png": 839,
	"./Blues.png": 840,
	"./Bruins.png": 841,
	"./Canadiens.png": 842,
	"./Canucks.png": 843,
	"./Capitals.png": 844,
	"./Coyotes.png": 845,
	"./Devils.png": 846,
	"./Ducks.png": 847,
	"./Flames.png": 848,
	"./Flyers.png": 849,
	"./Golden Knights.png": 850,
	"./Hurricanes.png": 851,
	"./Islanders.png": 852,
	"./Jets.png": 853,
	"./Kings.png": 854,
	"./Kraken.png": 855,
	"./Lightning.png": 856,
	"./Maple Leafs.png": 857,
	"./New York Rangers.png": 858,
	"./Oilers.png": 859,
	"./Panthers.png": 860,
	"./Penguins.png": 861,
	"./Predators.png": 862,
	"./Rangers.png": 863,
	"./Red Wings.png": 864,
	"./Sabres.png": 865,
	"./Senators.png": 866,
	"./Sharks.png": 867,
	"./Stars.png": 868,
	"./Wild.png": 869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;